import { render, staticRenderFns } from "./RightSheet.vue?vue&type=template&id=6dfa6d46&scoped=true&"
import script from "./RightSheet.vue?vue&type=script&lang=js&"
export * from "./RightSheet.vue?vue&type=script&lang=js&"
import style0 from "./RightSheet.vue?vue&type=style&index=0&id=6dfa6d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfa6d46",
  null
  
)

export default component.exports